import * as React from 'react';
import { connect } from "react-redux";
import { toast } from "react-toastify";
import { forgotPasswordEndPoint } from '../../../../common/api-config'
import { RouteComponentProps } from "react-router-dom";
import LoadingOverlay from "react-loading-overlay";
import axios from "axios";
import { bindActionCreators } from "redux";
import { IAuthenticationState, IApplicationState } from "../../../../models/applicationState";
import IAuthenticationActions, * as authenticationActions from "../../../../redux/actions/authenticationActions";
import HeaderComponent from "../header/header";

export interface IChangeUserPasswordProps extends RouteComponentProps, React.Props<ChangeUserPassword> {
    loggedInUser: IAuthenticationState;
    authenticationActions: IAuthenticationActions;
}

function mapStateToProps(state: IApplicationState) {
    return {
        loggedInUser: state.loggedInUser,
    };
}

export interface IChangeUserPasswordState {
    password: string;
    newPassword: string,
    patternMatch: any;
    confirmPassword: string,
    updatePassword: boolean;
    inputType: string;
    email: string;
}

function mapDispatchToProps(dispatch) {
    return {
        authenticationActions: bindActionCreators(authenticationActions, dispatch),
    };
}
@connect(mapStateToProps, mapDispatchToProps)

export default class ChangeUserPassword
    extends React.Component<IChangeUserPasswordProps, IChangeUserPasswordState> {
    public state: IChangeUserPasswordState = {
        password: "",
        newPassword: "",
        patternMatch: null,
        confirmPassword: "",
        inputType: "password",
        updatePassword: false,
        email: ""
    };

    public render() {
        return (
            <LoadingOverlay
                active={this.state.updatePassword}
                spinner
                className="wrap-queue-height"
                text="Updating password"
            >
                {this.props.loggedInUser ?
                    <>
                        <HeaderComponent
                            history={this.props.history}
                            match={this.props.match}
                            location={this.props.location} />
                        <div className="container">
                            <div className="row mt-5  justify-content-center">
                                {/* Change password */}
                                <div className="col-md-5" id="password">
                                    <div className="card  pl-3 pr-3 change-pw">
                                        <div>
                                            <br />
                                            <h5 className="float-left">Change Password</h5>

                                            <br />
                                            <hr />

                                        </div>

                                        <div className="row">
                                            <div className="col-12 hidden">

                                                <label >Old Password </label>
                                                <input type="text" className="form-control" name="first name" placeholder="John" ></input>

                                            </div>

                                            <div className="col-12">
                                                {/* // fa-eye-slash */}
                                                <label >New Password </label>
                                                <input value={this.state.newPassword} minLength={8} maxLength={25} type={this.state.inputType} autoComplete="new-password" onChange={this.getUpdatedPassword} className="form-control" id="newPassword" name="newPassword" placeholder="New password" />
                                                <span role="button" onClick={() => this.showPassword(this.state.inputType)}
                                                    className={this.state.inputType === "password" ? "fa fa-fw fa-eye field-icon" : "fa fa-fw fa-eye-slash field-icon"}></span>
                                                {this.state.patternMatch === false &&
                                                    <div className="text-danger">Must contain at least one number and one uppercase and lowercase letter</div>}
                                            </div>

                                            <div className="col-12">

                                                <label >Confirm Password </label>
                                                <input value={this.state.confirmPassword} type="password" autoComplete="nope" className="form-control" onChange={this.getUpdatedPassword} id="confirmPassword" name="confirmPassword" placeholder="Confirm Password" />
                                                {this.state.confirmPassword.length > 0 && this.state.newPassword !== this.state.confirmPassword &&
                                                    <div className="text-danger">Password not matched.</div>}
                                            </div>
                                        </div>



                                        <div className="row mt-3 mb-3 justify-content-center">

                                            <div className="col-md-12 text-center" >
                                                <button className="btn mr-2" role="button" onClick={this.backToRoute}>  Cancel </button >

                                                <button disabled={!this.state.password} className="btn" role="button" onClick={this.changePassword}>  Update </button >
                                            </div>


                                        </div>

                                    </div>
                                </div>

                            </div>

                        </div>
                    </> :
                    <div className="container">
                        <div className="row mt-5  justify-content-center">

                            {/* Forgot password */}

                            <div className="col-md-5" id="password">

                                <div className="card  pl-3 pr-3 change-pw">

                                    <div>
                                        <br />
                                        <h5 className="float-left">Forgot Password</h5>

                                        <br />
                                        <hr />

                                    </div>
                                    <div className="row">
                                        <div className="col-12">
                                            {/* // fa-eye-slash */}
                                            <label >Enter Your Email </label>
                                            <input type="email" onChange={this.getUpdatedPassword} className="form-control" id="emai" name="email" placeholder="Enter Email" />
                                        </div>
                                    </div>
                                    <div className="row mt-3 mb-3 justify-content-center">

                                        <div className="col-md-12 text-center" >
                                            <button className="btn mr-2" role="button" onClick={this.backToRoute}>  Cancel </button >
                                            <button className="btn mr-2" role="button" onClick={this.sendEmail}>  Submit </button >
                                        </div>


                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                }
            </LoadingOverlay>
        );
    }

    private getUpdatedPassword = (event: any) => {
        if (event.target.name === "newPassword") {
            if (event.target.value.length < 8) {
                this.setState({ patternMatch: false });
            } else {
                const re = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,20}/;
                const patternMatch = re.test(event.target.value);
                this.setState({ patternMatch });
            }
            this.setState({ newPassword: event.target.value });
        }
        if (event.target.name === "confirmPassword") {
            this.setState({ confirmPassword: event.target.value });
            if (this.state.newPassword === event.target.value) {
                this.setState({ password: event.target.value });
            }
        };

        if (event.target.name === "email") {
            this.setState({ email: event.target.value });
        }
    }

    private backToRoute = () => {
        this.props.history.goBack();
    }

    private sendEmail = async () => {
        const emailPattern = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.state.email);
        if (this.state.email && emailPattern) {
            this.setState({ updatePassword: true });
           const body = {
                email: this.state.email
            }
            axios(forgotPasswordEndPoint(), { method: "POST", data: body }).then(async (data) => {
                this.setState({ updatePassword: false });
                if (data.status === 200) {
                    toast.success("Password details sent to your registered mail", { position: toast.POSITION.TOP_CENTER });
                    this.props.history.goBack();
                }
            }).catch((err) => {
                this.setState({ updatePassword: false });
                toast.error(`Some thing went wrong.`, { position: toast.POSITION.TOP_CENTER });
            });
        } else {
            toast.warn("Please enter valid email address...!", { position: toast.POSITION.TOP_CENTER });
        }
    }

    private changePassword = () => {
        const requestBody = {
            // userId: this.props.loggedInUser.user.oid,
            password: this.state.password,
            confirm_password: this.state.confirmPassword

        }
        this.setState({ updatePassword: true });
        this.props.authenticationActions.changeUserPassword(requestBody).then((data: any) => {
            this.setState({ updatePassword: false });
            // toast.success("Password updated successfully ...!", { position: toast.POSITION.TOP_CENTER });
            this.props.history.goBack();
            if (data.status === 200) {
                this.setState({ updatePassword: false });
                toast.success("Password updated successfully ...!", { position: toast.POSITION.TOP_CENTER });
            } else {
                this.setState({ updatePassword: false });
                toast.warn("Some thing went wrong", { position: toast.POSITION.TOP_CENTER });
            }
        }).catch((err) => {
            this.setState({ updatePassword: false });
            toast.warn("Some thing went wrong", { position: toast.POSITION.TOP_CENTER });
        });
    }

    private showPassword = (inputTypeValue) => {
        const inputType = inputTypeValue === "password" ? "test" : "password";
        this.setState({ inputType });
    }
}
